module.exports = __webpack_public_path__ + "static/img/many_classes.c621cb8f.svg";